<ct-lib-modal
  [small]="true"
  class="tfa-app-modal"
  [hideFooter]="true"
  (onOpenEnd)="onOpenEnd()"
  (onCloseEnd)="onCloseEnd()"
  [label]="'jobboard.platform.settings.tfa.app-modal.title' | transloco"
  #appModal
>
  <div class="illustration">
    @if (!tfaAppInput.validated) {
      <img src="./assets/animations/line-arts/tfa/app_enter.svg" alt="" @fadeInOut />
    }
    @if (tfaAppInput.validated && tfaAppInput.valid) {
      <img src="./assets/animations/line-arts/tfa/app_success.svg" alt="" @fadeInOut />
    }
    @if (tfaAppInput.validated && !tfaAppInput.valid) {
      <img src="./assets/animations/line-arts/tfa/app_failed.svg" alt="" @fadeInOut />
    }
  </div>
  <p class="text-center" [innerHTML]="'jobboard.platform.settings.tfa.app-modal.enter-code' | transloco"></p>
  <app-platform-tfa-input
    [autoSubmit]="true"
    (submit)="onSubmit($event)"
    #tfaAppInput
  ></app-platform-tfa-input>
  <p class="text-center" [innerHTML]="'jobboard.platform.settings.tfa.lost-help' | transloco"></p>
</ct-lib-modal>
